import React from "react";
import PrivacyHeader from "./header";
import { usePrivacies } from "../../hooks/apis/main";
import parse from "html-react-parser";

function Privacy_content() {
  const { data, isLoading, error } = usePrivacies();
  if (isLoading) return <div className="active loading">
    <img src="/images/loading.svg" className="img-fluid" />
  </div>;
  if (error) return <p>Error</p>;
  return (
    <div id="privacy">
      <PrivacyHeader />
      <div className="privacy-content">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="text">{parse(data?.data?.page_detail.description)}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Privacy_content;
